import type { ComponentProps } from 'react';
import React, { useMemo } from 'react';
import styled from '@emotion/styled';
import type { FlexProps } from 'styled-system';
import { flex } from 'styled-system';

import { BodyRegularBR2 } from '../Typography';
import type { SuggestionItem } from './types';
import { createHighlightedText } from './utils/search';

interface SuggestionsListItemNameProps {
  suggestionsItem: SuggestionItem;
  inputValue: string;
}

const Container = styled(BodyRegularBR2)<FlexProps>`
  ${flex};
`;

const containerStyles: ComponentProps<typeof Container> = {
  flex: '1 1 auto',
  color: 'inherit',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  py: 'sp_2',
  ml: 'sp_8',
};

const useHighlightedText = ({ name }: SuggestionItem, inputValue: string) =>
  useMemo(() => createHighlightedText(name, inputValue), [name, inputValue]);

const SuggestionsListItemName = ({ suggestionsItem, inputValue }: SuggestionsListItemNameProps) => {
  const highlightedText = useHighlightedText(suggestionsItem, inputValue);

  return (
    <Container
      dangerouslySetInnerHTML={{ __html: highlightedText }}
      data-testid="suggestions-list-item-name"
      {...containerStyles}
    />
  );
};

export default SuggestionsListItemName;
